// InsightFlowSection.jsx
// Renders the 6-step Insight Flow: Reality → Activation → Patterns →
// Understanding → Action → Awareness.
// This is the "what's in it for me" section — each step is framed as a user benefit.
// Source: SysMindX Astro System Architecture & Insight Flow diagram.
import React from "react";

export default function InsightFlowSection({
  heading,
  subheading,
  steps = [],
  note,
}) {
  return (
    <div className="sx-container">
      <div className="sx-insight-wrapper">
        {heading && <h3 className="sx-pipeline-heading">{heading}</h3>}
        {subheading && <p className="sx-pipeline-sub">{subheading}</p>}

        <div className="sx-insight-grid">
          {steps.map((step, i) => (
            <div key={i} className="sx-insight-card">
              {/* Step number + icon */}
              <div className="sx-insight-card-top">
                <div className="sx-insight-card-num">{String(i + 1).padStart(2, "0")}</div>
                <div className="sx-insight-card-icon">{step.icon}</div>
              </div>

              {/* Phase label (WHAT EXISTS, WHAT IS ACTIVE, etc.) */}
              <div className="sx-insight-card-label">{step.label}</div>

              {/* Step title */}
              <div className="sx-insight-card-title">{step.title}</div>

              {/* Technical description — what the engine does */}
              <div className="sx-insight-card-what">{step.what}</div>

              {/* User benefit — what they actually get */}
              <div className="sx-insight-card-benefit">{step.benefit}</div>
            </div>
          ))}
        </div>

        {/* Bottom note */}
        {note && <p className="sx-insight-note">{note}</p>}
      </div>
    </div>
  );
}
